import { render, staticRenderFns } from "./CampaignInfoCards.vue?vue&type=template&id=1bd4f50b&scoped=true"
import script from "./CampaignInfoCards.vue?vue&type=script&lang=js"
export * from "./CampaignInfoCards.vue?vue&type=script&lang=js"
import style0 from "./CampaignInfoCards.vue?vue&type=style&index=0&id=1bd4f50b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd4f50b",
  null
  
)

export default component.exports